






































import { Component, Prop, Mixins, Emit } from 'vue-property-decorator';
import { LoadingIndicator } from '@/components/loading-indicator/LoadingIndicator.tsx';
import { AddToShoppingCartIcon } from '@/components/icons/AddToShoppingCartIcon';
import BaseMixin from '@/mixins/BaseMixin';
import { ShoppingCartModuleTypes } from '@/store/modules/shopping-cart';
import { isNullOrWhitespace } from '@/helper/isNullOrWhitespace';

@Component({
    components: {
        LoadingIndicator,
        AddToShoppingCartIcon,
    },
})
export default class ShoppingCartActions extends Mixins(BaseMixin) {
    @Prop(String)
    private fullPartId!: string;
    @Prop(String)
    private partNumber!: string;
    @Prop(String)
    private unitCode!: string;
    @Prop(Boolean)
    private hideUnitCode!: boolean;
    @Prop(Boolean)
    private showHorizontal!: boolean;
    @Prop({ type: Boolean, required: false, default: true })
    private positionAbsolute!: boolean;
    @Prop({ type: Number, required: false, default: 1 })
    private defaultQuantity!: number;
    @Prop(Number)
    private maxAllowedQuantity?: number;

    private currentQuantity: number = this.defaultQuantity;
    private lastEmittedQuantityValid?: boolean;
    private quantityHasFocus: boolean = false;

    private get isQuantityValid(): boolean {
        const isValid = (
            this.currentQuantity > 0 &&
            (this.maxAllowedQuantity === undefined || this.currentQuantity <= this.maxAllowedQuantity)
        );

        // only emit value when last emitted value is different from current
        if (this.lastEmittedQuantityValid === isValid) {
            return isValid;
        }
        if (isValid) {
            this.emitQuantityIsValid();
        } else {
            this.emitQuantityIsInvalid();
        }
        this.lastEmittedQuantityValid = isValid;

        return isValid;
    }

    private get hasActiveShoppingCart(): boolean {
        return this.$store.getters[ShoppingCartModuleTypes.getters.hasActiveShoppingCart];
    }

    private get isItemCurrentlyBeingAdded(): boolean {
        return this.$store.getters[ShoppingCartModuleTypes.getters.isItemCurrentlyBeingAdded](this.fullPartId);
    }

    private get isDisabled(): boolean {
        return (
            !this.isQuantityValid ||
            this.isItemCurrentlyBeingAdded ||
            !this.hasActiveShoppingCart ||
            isNullOrWhitespace(this.fullPartId)
        );
    }

    @Emit('quantity-changed')
    private emitQuantityChanged(): number {
        return this.currentQuantity;
    }

    @Emit('quantity-valid')
    private emitQuantityIsValid(): void {
        return;
    }

    @Emit('quantity-invalid')
    private emitQuantityIsInvalid(): void {
        return;
    }

    private quantityChanged(): void {
        if (this.isQuantityValid && this.quantityHasFocus) {
            this.emitQuantityChanged();
        }
    }

    private quantityFocusStateChanged(hasFocus: boolean): void {
        this.quantityHasFocus = hasFocus;
    }

    private async onAddItemToShoppingCart(): Promise<void> {
        await this.$store.dispatch(ShoppingCartModuleTypes.actions.addShoppingCartItem, {
            fullPartId: this.fullPartId,
            partNumber: this.partNumber,
            quantity: this.currentQuantity,
        });
        this.currentQuantity = this.defaultQuantity;
        this.emitQuantityChanged();
    }
}
